import React, { Component } from 'react';
import styles from './styles.scss';
import LodIcon from 'components/util/lodIcon';

export default class Pagination extends Component {
  setPage = increment => {
    this.props.onChange(this.props.pagination.current_page + increment);
  };

  render() {
    const { pagination } = this.props;
    if (pagination && pagination.total_pages > 1) {
      return (
        <div className={styles.wrapper}>
          <div className={styles.inner}>
            <div
              onClick={() => this.setPage(-1)}
              className={styles.iconWrapper}>
              {pagination.current_page > 1 && <LodIcon icon="chevronLeft" />}
            </div>
            <div style={{ paddingBottom: '5px' }}>
              Page {pagination.current_page} of {pagination.total_pages}
            </div>
            <div onClick={() => this.setPage(1)} className={styles.iconWrapper}>
              {pagination.current_page < pagination.total_pages && (
                <LodIcon icon="chevronRight" />
              )}
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pagination/index.js